<template>
  <b-media tag="li">
    <template v-slot:aside>
      <span class="bg-orange pt-3 pl-1 media-wrapper">
        <font-awesome-icon
          class="text-white align-middle"
          icon="flag"
          size="2x"
        ></font-awesome-icon>
      </span>
    </template>
    <h5 class="mt-0 mb-3 text-left">
      <!--      <strong><i>How the Challenge was addressed</i></strong>: {{ challenge.description }}-->
      {{ challenge.description }}
    </h5>
    <p v-if="challenge.solution" class="mb-0 text-left">
      <span style="white-space: pre-wrap; overflow-wrap: break-word"
        ><strong>Ways to address the challenge</strong>: {{ challenge.solution
        }}<span v-if="challenge.solution.slice(-1) !== '.'">.</span> <br
      /></span>
      <!--      <span class="text-justify ">Solution: {{ challenge.solution }}. View the resources below:<br></span>-->
      <!--        <span v-for="record in challenge.resources" v-bind:key="record.resource.id">-->
      <!--          - <router-link :to="{ name: 'resourceView', params: { id: record.resource.id }}">{{ record.resource.title }}</router-link>-->
      <!--          <br>-->
      <!--        </span>-->
    </p>
  </b-media>
</template>

<script>
export default {
  name: "RecipeChallenge",
  props: {
    challenge: Object,
  },
};
</script>

<style scoped>
.media-wrapper {
  width: 64px;
  height: 64px;
}
</style>



// WEBPACK FOOTER //
// src/components/recipes/RecipeChallenge.vue